import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1252_16228",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1252_16228)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.0003 18.5834C8.81296 18.5834 7.69713 18.3581 6.65283 17.9074C5.60852 17.4568 4.70012 16.8453 3.92762 16.0728C3.15512 15.3003 2.54359 14.3919 2.09303 13.3476C1.64234 12.3033 1.41699 11.1874 1.41699 10.0001H2.50033C2.50033 12.0556 3.20574 13.8059 4.61658 15.2509C6.02727 16.6959 7.74491 17.4547 9.76949 17.5274L7.80491 15.5626L8.57887 14.7886L12.0901 18.2788C12.0612 18.2779 11.8505 18.3283 11.4578 18.4303C11.0652 18.5324 10.5794 18.5834 10.0003 18.5834ZM10.6285 11.872V8.12821H13.0324C13.1713 8.12821 13.2894 8.17612 13.3866 8.27196C13.4838 8.36779 13.5324 8.48654 13.5324 8.62821V11.372C13.5324 11.5136 13.4845 11.6324 13.3887 11.7282C13.2928 11.824 13.1741 11.872 13.0324 11.872H10.6285ZM6.46824 11.872V11.1282H8.62845V10.3686H7.46824V9.63154H8.62845V8.87196H6.46824V8.12821H9.00033C9.1056 8.12821 9.19394 8.16383 9.26533 8.23508C9.33658 8.30647 9.3722 8.3948 9.3722 8.50008V11.5001C9.3722 11.6054 9.33658 11.6937 9.26533 11.7651C9.19394 11.8363 9.1056 11.872 9.00033 11.872H6.46824ZM11.3722 11.1282H12.6926C12.7247 11.1282 12.7487 11.1202 12.7647 11.1042C12.7808 11.0883 12.7889 11.0642 12.7889 11.0322V8.968C12.7889 8.93591 12.7808 8.91189 12.7647 8.89592C12.7487 8.87994 12.7247 8.87196 12.6926 8.87196H11.3722V11.1282ZM17.5003 10.0001C17.5003 7.94453 16.7949 6.19425 15.3841 4.74925C13.9734 3.30425 12.2557 2.54543 10.2312 2.47279L12.1957 4.43758L11.4218 5.21154L7.91053 1.72133C7.93942 1.7223 8.15019 1.67182 8.54283 1.56987C8.93546 1.46779 9.4213 1.41675 10.0003 1.41675C11.1877 1.41675 12.3035 1.6421 13.3478 2.09279C14.3921 2.54335 15.3005 3.15487 16.073 3.92737C16.8455 4.69987 17.4571 5.60828 17.9076 6.65258C18.3583 7.69689 18.5837 8.81272 18.5837 10.0001H17.5003Z",
			fill: "currentColor"
		})
	})]
});
export default SvgQuickView;
